import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class ProfileService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) { }

  getPopup(popupId): Observable<any> {
    const url = environment.apiBase + `users/${popupId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  updateProfileDetails(body): Observable<any> {
    const url = environment.apiBase + `users/${body.popupId}`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body.update, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/profile.service.ts